module.exports = __webpack_public_path__ + "img/tree-08-d-trunk.167b34bc.png";